import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import type { RootState } from '../../../store';

export default function useTreatmentPlanV3PlanBay() {
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const planId = useSelector((state: RootState) => state.treatmentPlans.current?.id);
  const bay = useSelector((state: RootState) => state.treatmentPlans.current?.bay);
  return planId != null && String(planId) === treatmentPlanId ? bay : undefined;
}
